export const getInsertInstructionStyle = () => ({
  container: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#323130',
    marginBottom: '12px',
  },
  steps: {
    fontSize: '14px',
    marginBottom: '12px',
  },
});
